<template>
    <div class="voucher-root">
        <iframe :src="`${serverPath}/tools/comprobante-compra?buyorder=${$route.params.buyorder}`" type="application/pdf"  title="PDF in an i-Frame"  frameborder="0" height="100%" width="100%" />
    </div>
</template>

<script>

export default {
    components : {

    },
    data() {
      return {
        serverPath : process.env.VUE_APP_API_URL
      }
    }
}
</script>

<style lang="scss" scoped>
    .voucher-root {
        overflow: hidden;
        height : 100vh
    }
</style>